export default __webpack_public_path__ + "static/media/mapMarkerHighlight.616b17be.svg";